<template>
  <div
    class="d-flex flex-column flex-fill p-relative card__wrapper"
  >
    <v-container
      fluid
      class="pa-0 ma-0"
      v-if="!itemLote['blBaixa'] && !itemLote['blCarencia']"
    >
      <v-row class="ma-0 pa-0 no-grace-and-casualty__row" />
    </v-container>
    <v-card
      flat
      height="100%"
      width="100%"
      :disabled="itemLote.blDeleted"
      class="card-com-lote-alocado"
      :class="[
        {
          'grace-period': itemLote['blCarencia'] && !itemLote['blBaixa'],
          casualty: itemLote['blBaixa'] && !itemLote['blCarencia'],
          'grace-and-casualty': itemLote['blBaixa'] && itemLote['blCarencia'],
          'cutting-card': isProgCutting,
        },
      ]"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-row
            v-show="itemLote['blCarencia'] && !itemLote['blBaixa']"
            align="center"
            v-on="on"
            class="ma-0 grace-period__row px-4"
          >
            <v-icon left small color="white"
              >fas fa-prescription-bottle-alt
            </v-icon>
            <span>Lote em carência</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote em período de carência</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Medicamento:</span>
            <span class="tooltip__text-bold pl-1">{{
              (itemLote && itemLote["nmFarmaco"]) || ""
            }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Data Final:</span>
            <span class="tooltip__text-bold pl-1">{{
              itemLote
                ? $options.filters.datetimeFormat(itemLote["dtCarencia"])
                : ""
            }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-row
            v-show="itemLote['blBaixa'] && !itemLote['blCarencia']"
            align="center"
            v-on="on"
            class="ma-0 casualty__row px-4"
          >
            <v-icon left small color="white">fas fa-book-dead</v-icon>
            <span>Lote com mortalidade</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote com baixa informada</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Nº de mortes:</span>
            <span class="tooltip__text-bold">{{
              (itemLote && itemLote["qtBaixa"]) || ""
            }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-row
            v-show="itemLote['blBaixa'] && itemLote['blCarencia']"
            align="center"
            v-on="on"
            class="ma-0 grace-and-casualty__row px-4"
          >
            <v-icon left small color="white"
              >fas fa-prescription-bottle-alt
            </v-icon>
            <v-icon left small color="white">fas fa-book-dead</v-icon>
            <span>Lote com carência e mortalidade</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold"
              >Lote com baixa e carência informada</span
            >
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Nº de mortes:</span>
            <span class="tooltip__text-bold">{{
              (itemLote && itemLote["qtBaixa"]) || ""
            }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Medicamento:</span>
            <span class="tooltip__text-bold pl-1">{{
              (itemLote && itemLote["nmFarmaco"]) || ""
            }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Data Final:</span>
            <span class="tooltip__text-bold pl-1">{{
              itemLote
                ? $options.filters.datetimeFormat(itemLote["dtCarencia"])
                : ""
            }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-layout row align-center ma-0 pa-2>
        <span class="label-produtor">Produtor</span>
        <v-spacer />

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
<!--            v-if="programacaoAbateSelected.cdStatusProgramacaoAbate != 5"-->
            <v-btn
              v-bind="attrs"
              v-on="on"
              depressed
              icon
              x-small
              @click="copyBatchAllocated(itemLote)"
              class="mx-1 card-actions__btn cut"
            >
              <v-icon x-small color="white">fas fa-copy</v-icon>
            </v-btn>
          </template>
          <span>Copiar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
<!--            v-if="programacaoAbateSelected.cdStatusProgramacaoAbate != 5"-->
            <v-btn
              
              v-bind="attrs"
              v-on="on"
              depressed
              icon
              x-small
              @click="cutBatchAllocated(itemLote)"
              class="mx-1 card-actions__btn cut"
            >
              <v-icon x-small color="white">fas fa-cut</v-icon>
            </v-btn>
          </template>
          <span>Recortar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              depressed
              icon
              x-small
              color="#BDCCCA"
              class="mx-1 card-actions__btn info"
            >
              <v-icon x-small color="white">fas fa-info</v-icon>
            </v-btn>
          </template>
          <span>
            <span class="title-tooltip">Lote:</span>
            <span class="value-tooltip pl-1">
              {{ itemLote.loteProducao.nrLoteControle }}
            </span>
            <br />
            <span class="title-tooltip">Extensionista:</span>
            <span class="value-tooltip pl-1">
              {{
                (itemLote.extensionista && itemLote.extensionista.nmPessoa) ||
                ""
              }}
            </span>
            <br />
            <span class="title-tooltip">Cidade:</span>
            <span class="value-tooltip pl-1">
              {{ itemLote.nmMunicipio }}
            </span>
          </span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
<!--            :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate === 5"-->
            <v-btn
              v-bind="attrs"
              v-on="on"
              depressed
              icon
              x-small
              color="#ff5252"
              @click.native="removeBatchAlocated(itemLote)"
              class="mx-1 card-actions__btn delete"
            >
              <v-icon x-small color="white">fas fa-trash</v-icon>
            </v-btn>
          </template>
          <span>Remover</span>
        </v-tooltip>
      </v-layout>
      <v-layout row justify-start ma-0 pb-2>
        <v-flex lg11 pl-5>
          <span class="nome-produtor">{{
            itemLote.loteProducao.jsonProdutor.nmProdutor
          }}</span>
        </v-flex>
      </v-layout>
      <v-row class="ma-0 px-4 infos-lote">
        <v-col cols="6" class="pa-0 py-2">
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Gênero</span>
            <span class="value-card-dados-lote pl-1">
              {{ itemLote.dsTipoSexo }}
            </span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Tipo</span>
            <span class="value-card-dados-lote pl-1">
              {{
                itemLote.loteProducao.jsonUnidadeExploracao
                  .csTipoUnidadeExploracao
              }}
            </span>
          </v-row>
        </v-col>
        <v-col cols="6" class="pa-0 py-1">
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Distância</span>
            <span class="value-card-dados-lote pl-1">
              {{ itemLote.distanciaPlanta.nrValor }}
            </span>
            <span class="value-card-dados-lote pl-1">
              {{ itemLote.distanciaPlanta.dsTipo }}
            </span>
          </v-row>
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Alojamento</span>
            <span class="value-card-dados-lote pl-1"
              >{{ itemLote.nrDiasAlojado }} d</span
            >
          </v-row>
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Peso</span>
            <span class="value-card-dados-lote pl-1"
              >{{ itemLote.nrPesoDia }} kg</span
            >
          </v-row>
        </v-col>
      </v-row>
      <v-layout row justify-center ma-0 px-1 pt-1>
        <v-flex lg6 md-12 pr-1>
<!--          :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate == 5"-->
          <v-text-field
            dense
            v-only-int
            v-model.number="qtAnimais"
            placeholder="Qtd Animais"
            label="Qtd. Animais"
            outlined
            @blur="() => $v.$touch()"
            @change="changeAnimais"
            :error-messages="qtAnimaisErrors"
          ></v-text-field>
        </v-flex>
        <v-flex lg6 md-12 class="d-flex flex-column text-right" pl-1>
          <span class="label-card-dados-lote text-truncate text-right"
            >Disponível Previsto</span
          >
          <span
            :class="
              qtdDisponiveis >= 0
                ? 'value-animais-disponiveis-positive'
                : 'value-animais-disponiveis-negative'
            "
            >{{ qtdDisponiveis }}</span
          >
        </v-flex>
      </v-layout>
      <v-row
        align="center"
        class="ma-0"
      >
        <v-col
          cols="12"
          class="d-flex flex-column pt-0"
        >
          <span class="label-card-dados-lote text-truncate text-right">Disponível Real</span>
          <span
            class="value-animais-disponiveis-positive"
          >
            {{itemLote.qtSaldoAtual}}
          </span>
          <gta-list-dialog
            :gta-list="itemLote['listaSaidaAnimais']"
            :qt-saidas="itemLote['qtSaidas']"
          >
            <template v-slot:activator="on">
              <v-btn
                v-on="on"
                absolute
                left
                depressed
              >
                GTAs
              </v-btn>
            </template>
          </gta-list-dialog>
        </v-col>
      </v-row>
      <v-layout row justify-center ma-0 px-1 py-1>
        <v-flex lg12 v-if="!itemLote.editarPeso">
<!--          :disabled="programacaoAbateSelected.cdStatusProgramacaoAbate == 5"-->
          <v-btn
            
            outlined
            large
            block
            color="#0CA5A2"
            class="btn-editar-lote"
            @click="changeEditarPeso(itemLote)"
            >Editar Peso
          </v-btn>
        </v-flex>
        <v-flex lg12 pa-0 v-else>
          <v-text-field
            dense
            v-model.number.trim="nrPeso"
            placeholder="Peso médio"
            label="Peso médio"
            outlined
            hide-details
            v-only-number
          />
        </v-flex>
      </v-layout>
    </v-card>
    <v-overlay v-if="itemLote['blDeleted']" absolute>
      <v-row justify="center" align="center" class="ma-0">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              fab
              depressed
              color="#2BC1B6"
              class="white--text"
              @click="recoverBatchAllocated(itemLote)"
              v-on="on"
            >
              <v-icon>fas fa-undo</v-icon>
            </v-btn>
          </template>
          <span>Desfazer</span>
        </v-tooltip>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { daysBetweenDates } from "@/filters/utils";
import { validationMixin } from "vuelidate";
import required from "vuelidate/lib/validators/required";
import maxValue from "vuelidate/lib/validators/maxValue";
import moment, { ISO_8601 } from "moment";
import GtaListDialog from "@/modules/programacaoAbate/components/LotTab/GtaListDialog"

export default {
  name: "CardItemLoteAlocado",
  components: {GtaListDialog},
  mixins: [validationMixin],
  props: {
    itemData: {
      type: Object,
      default: {},
    },
    itemPlanta: {
      type: Object,
      default: {},
    },
    itemLote: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      lazyModel: {
        idProgramacaoAbateAlocado: this.itemLote.idProgramacaoAbateAlocado,
        cdProgramacaoAbate: this.itemLote.cdProgramacaoAbate,
        cdLoteProducao: this.itemLote.cdLoteProducao,
        cdPlantaAbate: this.itemLote.cdPlantaAbate,
        stDiaAlocado: this.itemLote.stDiaAlocado,
        qtAnimaisAlocados: this.itemLote.qtAnimaisAlocados,
        nrPesoDia: this.itemLote.nrPesoDia,
        dtAlocado: this.itemLote.dtAlocado,
        blConfirmado: this.itemLote.blConfirmado,
      },
    };
  },
  validations() {
    return {
      qtAnimais: {
        required,
        max: maxValue(this.qtdDisponiveisWithoutLot),
      },
    };
  },
  filters: {
    datetimeFormat: (value, format = "DD/MM/Y") => {
      const parsedDate = moment(value, ISO_8601);
      if (!parsedDate.isValid()) return "";
      return parsedDate.format(format);
    },
  },
  computed: {
    qtAnimais: {
      get() {
        return this.itemLote.qtAnimaisAlocados;
      },
      set(value) {
        this.setLoteAlocadoQtAnimais({
          idProgramacaoAbateAlocado: this.itemLote.idProgramacaoAbateAlocado,
          value: parseInt(value) || 0,
        });
      },
    },
    nrPeso: {
      get() {
        return this.itemLote.nrPesoDia;
      },
      set(val) {
        this.setLoteAlocadoNrPeso({
          idProgramacaoAbateAlocado: this.itemLote.idProgramacaoAbateAlocado,
          value: parseFloat(parseFloat(val).toFixed(2)) || 0,
        });
      },
    },
    qtAnimaisErrors() {
      const errors = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.qtAnimais.required && errors.push("Campo obrigatório");
      if (!this.$v.qtAnimais.max)
        if (this.qtdDisponiveisWithoutLot <= 0)
          errors.push(`Não há animais disponíveis`);
        else errors.push(`O valor máximo é ${this.qtdDisponiveisWithoutLot}`);
      return errors;
    },
    qtdDisponiveis() {
      const sumTotalByLot = this.listBatchsAllocated.reduce((acc, curr) => {
        if (
          curr.cdLoteProducao === this.itemLote.cdLoteProducao &&
          !curr.blDeleted
        )
          acc += parseInt(curr.qtAnimaisAlocados) || 0;
        return acc;
      }, 0);
      // console.log(`Saldo Real: ${(parseInt(this.itemLote.qtSaldoReal) || 0)}`)
      // console.log(`Qt Animais Programado Abate: ${(parseInt(this.itemLote.loteProducao.qtAnimaisProgramadoAbate) || 0)}`)
      // console.log(`Qt Animais Alocado ${this.itemLote.idProgramacaoAbateAlocado}: ${sumTotalByLot}`)
      return (
        (parseInt(this.itemLote.qtSaldoReal) || 0) -
        (parseInt(this.itemLote.loteProducao.qtAnimaisProgramadoAbate) || 0) -
        sumTotalByLot
      );
    },
    qtdDisponiveisWithoutLot() {
      const sumTotalByLot = this.listBatchsAllocated.reduce((acc, curr) => {
        if (
          curr.cdLoteProducao === this.itemLote.cdLoteProducao &&
          curr.idProgramacaoAbateAlocado !==
            this.itemLote.idProgramacaoAbateAlocado &&
          !curr.blDeleted
        )
          acc += parseInt(curr.qtAnimaisAlocados) || 0;
        return acc;
      }, 0);
      const qtdDisponiveis =
        (parseInt(this.itemLote.qtSaldoReal) || 0) -
        (parseInt(this.itemLote.loteProducao.qtAnimaisProgramadoAbate) || 0) -
        sumTotalByLot;
      return qtdDisponiveis;
    },
    isProgCutting() {
      return (
        this.itemLote["idProgramacaoAbateAlocado"] ===
        this.idProgramacaoAbateAlocadoToCopy
      );
    },
    ...mapState("programacaoAbate", [
      "listBatchsAllocated",
      "programacaoAbateSelected",
      "idProgramacaoAbateAlocadoToCopy",
    ]),
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionLoadDistanciaPlantaAbateEstabelecimento",
      "ActionChangeEditWeight",
      "ActionChangeQtAnimalsItem",
      "ActionChangeWeightValueItem",
      "ActionDeleteProgramingBatchAllocated",
      "ActionRecoverDeletedBatchAllocated",
      "setLoteAlocadoQtAnimais",
      "setLoteAlocadoNrPeso",
      "ActionCutProgAbateAlocado",
      "ActionCopyProgAbateAlocado",
    ]),
    daysBetweenDates,
    removeBatchAlocated(itemLote) {
      this.ActionDeleteProgramingBatchAllocated(itemLote);
    },
    copyBatchAllocated(itemLote) {
      this.ActionCopyProgAbateAlocado({
        idProgramacaoAbateAlocado: itemLote["idProgramacaoAbateAlocado"],
      });
    },
    cutBatchAllocated(itemLote) {
      this.ActionCutProgAbateAlocado({
        idProgramacaoAbateAlocado: itemLote["idProgramacaoAbateAlocado"],
      });
    },
    recoverBatchAllocated(itemLote) {
      this.ActionRecoverDeletedBatchAllocated(itemLote);
    },
    changeEditarPeso(itemLote) {
      this.ActionChangeEditWeight(itemLote);
    },
    changeAnimais() {
      this.$emit("animaisChanged");
    },
  },
};
</script>

<style scoped lang="scss">
.card__wrapper {
  border-radius: 5px;
}

.cutting-card {
  border: 2px dashed #777777 !important;
}

.gta-btn {
  right: 0;
  margin-right: 5px;
  background-image: repeating-linear-gradient(45deg, violet, indigo, blue, green, yellow, orange, red, violet);
  text-align: center;
  background-size: 800% 800%;
  //-webkit-background-clip: text;
  //-webkit-text-fill-color: transparent;
  font-size: 24px;
  animation: rainbow 8s ease infinite;
  transition: width 5s ease-in-out;
  
  &:hover {
    opacity: 0;
  }
}

@keyframes rainbow {
  0% {
    background-position: 0% 50%;
    transform: rotate(0deg);
  }
  50% {
      background-position: 100% 25%;
    transform: rotate(180deg);
  }
  100% {
      background-position: 0% 50%;
    transform: rotate(360deg);
  }
}

</style>
